import React from 'react';
import { CURRENCY, FORMAT_NUMBER } from "../../libs/utils/Const";
import moment from 'moment';

const renderTable = (header, body, idTable = 'dataTableTimbra') => {
    return (
        <table id={`${idTable}`} className="display" style={{ width: '100%' }}>
            <thead className="table-header">
                {header}
            </thead>
            <tbody>
                {body}
            </tbody>
        </table>
    );
};

const renderBodyTable = (header, body, view, action, idTable, actionLabel, viewTools) => {
    let bodyTable = <></>

    switch (view) {
        // case 'ambassadors':
        //     bodyTable = renderDynamicTable(body);
        //     break;
        case 'suggestRefillDoc':
            bodyTable = renderSuggestRefillDocModal(body, action, actionLabel, viewTools);
            break;
        case 'searchPartnerRefSys':
            bodyTable = renderSearchPartnerRefSys(body, action, actionLabel);
            break;
        case 'referredPartners':
            bodyTable = renderReferredPartners(body, action);
            break;
        case 'requestAmbassadors':
            bodyTable = renderRequestsAmbassador(body, action);
            break;
        case 'referSystemAdmin':
            bodyTable = renderReferSystemAdmin(body, action);
            break;
        case 'ambassadors':
            bodyTable = renderAmbassadors(body, action);
            break;
        case 'notiRefT1':
            bodyTable = notiRefT1(body, action);
            break;
        case 'notiRefT2':
            bodyTable = notiRefT2(body, action);
            break;
        default:
            bodyTable = <tr><td colSpan={header.length}>No data available</td></tr>;
            break;
    }
    return bodyTable;
}

export const tableStandarIndicators = (headers, data, view, action = () => { }, idTable, actionLabel, viewTools) => {
    const header = (
        <tr>
            {headers.map((header, index) => { return <td key={index + view} className="text-center">{header.title}</td> })}
        </tr>
    );
    const body = renderBodyTable(headers, data, view, action, idTable, actionLabel, viewTools);
    return renderTable(header, body, idTable);
};

const renderSearchPartnerRefSys = (data, action, actionLabel) => {
    const body = data.map((register, index) => (
        <tr id={`referredSearchPartnerSys-${index}`}>
            <td className="text-center" >{register?.CardCode ?? ''}</td>
            <td className="text-center" >{(register?.CardName ?? '')}</td>
            <td className="text-center" >{(register?.LicTradNum ?? '')}</td>
            <td className="text-center" >
                <button type="button" className="btn btn-timbra-one btn-sm botonCorrect" onClick={() => action(register)}>
                    {actionLabel}
                </button>
            </td>
        </tr>
    ));
    return body;
}

const renderSuggestRefillDocModal = (data, action, actionLabel, viewTools) => {

    const body = data.map((register, index) => {
        const disableAction = viewTools.action === 1 || (viewTools.action === 2 && viewTools.editMode && !register.LineStatus) ? false : true;
        return (

            <tr id={`suggestRefillDoc-${index}`}>
                <td className="text-center" >{register?.ItemCode ?? ''}</td>
                <td className="text-center" >{(register?.ItemName ?? '')}</td>
                <td className="text-center" >{(register?.WhsCode ?? '')}</td>

                <td className="text-center" >{(register?.MaxStock ?? '')}</td>
                <td className="text-center" >{(register?.MinStock ?? '')}</td>
                <td className="text-center" >{(register?.MinOrder ?? '')}</td>

                <td className="text-center" >{(register?.OnHand ?? '')}</td>
                <td className="text-center" >{(register?.RutaOnHand ?? '')}</td>
                <td className="text-center" >{(register?.CUsoOnHandGeneral ?? '')}</td>
                <td className="text-center" >{(register?.MovimientoDiario ?? '')}</td>
                <td className="text-center" >
                    {!disableAction
                        ?
                        <input
                            type="text"
                            id={`refillLine-${index}`}
                            autoComplete='off'
                            className=" form-control validarCant cantBlur btn-outline-secondary"
                            onChange={(ev) => viewTools.ChangeFieldValue(index, "Quantity", ev.target.value)}
                            value={register.Quantity ?? ''}
                        />
                        :
                        (register?.Quantity ?? '')
                    }


                </td>
                <td className="text-center" >
                    <button type="button" disabled={disableAction} className="btn btn-timbra-one btn-sm botonCorrect" onClick={() => action(index)}>
                        {actionLabel}
                    </button>
                </td>
            </tr>
        )
    });
    return body;
}


const renderReferredPartners = (data, action) => {
    const body = data.map((register, index) => (
        <tr id={`referred${index}`}>
            <td className="text-center" >{register?.CardCode ?? ''}</td>
            <td className="text-center" >{(register?.CardName)}</td>
            <td className="text-center" >{register?.Balance}</td>
            <td className="text-center" >REFERIDO</td>
            <td className="text-center" >{register?.GroupName}</td>
            <td className="text-center" >{register?.LicTradNum}</td>
            <td className="text-center" >{register?.U_FMB_RELATED_AMBASSADOR ?? ''}</td>
            <td className="text-center" >
                <button type="button" className="btn btn-timbra-one btn-sm botonCorrect" onClick={() => action(register)}>
                    <i className="far fa-file-alt">
                    </i> Ver Detalles
                </button>
            </td>
        </tr>
    ));
    return body;
}

const renderRequestsAmbassador = (data, action) => {
    const body = data.map((register, index) => (
        <tr id={`ambassadors${index}`}>
            <td className="text-center" >{register?.IdRFSP ?? ''}</td>
            <td className="text-center" >{(register?.MinAmount)}</td>
            <td className="text-center" >{register?.Type}</td>
            <td className="text-center" >{register?.Value}</td>
            <td className="text-center" >{register?.FromDate}</td>
            <td className="text-center" >{register?.ToDate}</td>
            <td className="text-center" >
                <button type="button" className="btn btn-timbra-one btn-sm botonCorrect" onClick={() => action(register)}>
                    <i className="far fa-file-alt">
                    </i> Ver Detalles
                </button>
            </td>
        </tr>
    ));
    return body;
}

const renderReferSystemAdmin = (data, action) => {
    const body = data.map((register, index) => {
        const type = Number(register?.Type)
        return (
            <tr id={`referSystemAdmin${index}`}>
                <td className="text-center" >{register?.IdRFSP ?? ''}</td>
                <td className="text-center" >{register?.MinAmount != null ? `${CURRENCY} ${FORMAT_NUMBER.new(register?.MinAmount)}` : ''}</td>
                <td className="text-center" >{type === 1 ? 'Importe fijo' : 'Porcentaje'}</td>
                <td className="text-center" >{register?.Value != null ? (type === 1 ? `${CURRENCY} ${FORMAT_NUMBER.new(register?.Value)}` : `${FORMAT_NUMBER.new(register.Value)} ${Number(register?.Type) === 2 ? '%' : ''}`) : ''}</td>
                <td className="text-center" >{register?.FromDate}</td>
                <td className="text-center" >{register?.ToDate}</td>
                <td className="text-center" >
                    <button type="button" className="btn btn-timbra-one btn-sm botonCorrect" onClick={() => action(register)}>
                        <i className="fa fa-trash">
                        </i> Eliminar
                    </button>
                </td>
            </tr>
        )
    });
    return body;
}

const renderAmbassadors = (data, action) => {
    const body = data.map((register, index) => (
        <tr id={`ambassadors${index}`}>
            <td className="text-center" >{register?.CardCode}</td>
            <td className="text-center" >{register?.CardName}</td>
            <td className="text-center" >{register?.Balance}</td>
            <td className="text-center" >{register?.GroupCode}</td>
            <td className="text-center" >{register?.GroupName}</td>
            <td className="text-center" >{register?.Currency}</td>
            <td className="text-center" >{register?.LicTradNum}</td>
            <td className="text-center" >
                <button type="button" className="btn btn-timbra-one btn-sm botonCorrect" onClick={() => action(register)}>
                    <i className="far fa-file-alt">
                    </i> Ver Detalles
                </button>
            </td>
        </tr>
    ));
    return body;
}

const notiRefT1 = (data, action) => {
    const body = data.map((register, index) => (
        <tr id={`notiRefT1${index}`}>
            {/* <td className="text-center" >{index + 1}</td> */}
            <td className="text-center" >{register?.Code}</td>
            <td className="text-center" >{register?.Name}</td>
            <td className="text-center" >
                <button type="button" className="btn btn-timbra-one btn-sm botonCorrect" onClick={() => action(register?.id, false)}>
                    <i className="fa fa-trash" />
                </button>
            </td>
        </tr>
    ));
    return body;
}

const notiRefT2 = (data, action) => {
    const body = data.map((register, index) => (
        <tr id={`notiRefT2${index}`}>
            {/* <td className="text-center" >{index + 1}</td> */}
            <td className="text-center" >{moment(register.creation_date).format('YYYY-MM-DD HH:mm:ss')}</td>
            <td className="text-center" >{register?.message}</td>
        </tr>
    ));
    return body;
}

const renderDynamicTable = (data) => {
    const body = data.map((register, index) => (
        <tr key={index}>
            {Object.keys(register).map((key) => (
                <td key={key} className="text-center" style={{ width: "100px" }}>
                    {register[key]}
                </td>
            ))}
        </tr>
    ));
    return body;
};
